var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '../Tooltip';
import SvgExclamation from '../svg/Exclamation.js';
import styles from './Input.scss';

var InputErrorSuffix = function (_React$Component) {
  _inherits(InputErrorSuffix, _React$Component);

  function InputErrorSuffix() {
    _classCallCheck(this, InputErrorSuffix);

    return _possibleConstructorReturn(this, (InputErrorSuffix.__proto__ || Object.getPrototypeOf(InputErrorSuffix)).apply(this, arguments));
  }

  _createClass(InputErrorSuffix, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        Tooltip,
        {
          dataHook: 'input-tooltip',
          disabled: this.props.errorMessage.length === 0,
          placement: 'top',
          moveBy: { x: 2, y: 0 },
          alignment: 'center',
          content: this.props.errorMessage,
          overlay: '',
          theme: 'dark',
          hideDelay: 150
        },
        React.createElement(
          'div',
          { className: styles.exclamation },
          React.createElement(SvgExclamation, { width: 2, height: 11 })
        )
      );
    }
  }]);

  return InputErrorSuffix;
}(React.Component);

InputErrorSuffix.propTypes = {
  theme: PropTypes.oneOf(['normal', 'paneltitle', 'material', 'amaterial']),
  errorMessage: PropTypes.string.isRequired,
  focused: PropTypes.bool
};

export default InputErrorSuffix;
//# sourceMappingURL=InputErrorSuffix.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Input/InputErrorSuffix.js